import React, {useEffect} from "react";
import { Image } from "../../../../../components/Image";
import "./style.css";

export const MobileUserScale = ({ clickNext = () => {}, clickPrev = () => {}, clicked}) => {
    useEffect(() => {
        if (clicked) {
            clickNext("")
        }
    }, [clicked]);

  return (
    <div className="user-scale">
        <div className={'img-wrap'}>
            <Image src="/static/image/questionnaire/fasting/userScale/UserScale img_bg.png" alt="Img" className="img object-cover"/>
        </div>

      <div className="contents">
        <div className="title">
            <div className={"main-title"}>
                <span className="main-title-highlight">3 Million</span>
                <span>People</span>
            </div>
          <p className="subtitle">
              have achieved their weight goals by fasting with Calo
          </p>
        </div>
      </div>
    </div>
  );
};
